module.exports = __webpack_public_path__ + "static/Portfolio18-bf911ccd1bf55bfabc58f896b9bbd9d1.jpg";